import { DEFAULT_DASHBOARD_PERF_SAMPLE_RATE } from './constants';

export function dashboardPerfSampleRate(): number {
  const raw = process.env.NEXT_PUBLIC_POSTHOG_DASHBOARD_PERF_SAMPLE_RATE;
  if (raw == null || raw === '') return DEFAULT_DASHBOARD_PERF_SAMPLE_RATE;
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return 0;
  if (n >= 1) return 1;
  return n;
}

export function shouldSampleDashboardPerf(loadId: string): boolean {
  const rate = dashboardPerfSampleRate();
  if (rate >= 1) return true;
  if (rate <= 0) return false;
  let hash = 0;
  for (let i = 0; i < loadId.length; i++) {
    hash = (hash * 31 + loadId.charCodeAt(i)) | 0;
  }
  const normalized = Math.abs(hash % 10_000) / 10_000;
  return normalized < rate;
}
